(() => {
  const teaser = document.querySelector('[data-fnk-offer-teaser]');
  if (!teaser || teaser.dataset.initialized) return;
  teaser.dataset.initialized = 'true';
  const button = teaser.querySelector('button');
  const header = button.hasAttribute('data-welcome-v2-opener') ? document.querySelector('#header-component') : null;
  if (!header && teaser.dataset.placement === 'header') {
    teaser.dataset.placement = 'side';
    teaser.setAttribute('popover', 'manual');
  }

  const formId = button.dataset.formId;
  const status = document.getElementById('fnk-offer-teaser-status');
  let busy = false;
  let scheduled = false;
  let returnCart = null;
  let failureTimer;

  function render() {
    scheduled = false;
    const welcomeOpen = document.querySelector('[data-fnk-welcome-v2][open]');
    if (header) {
      if (teaser.parentElement !== header) header.append(teaser);
      teaser.style.visibility = welcomeOpen || document.querySelector('dialog:modal') ? 'hidden' : '';
      return;
    }
    teaser.style.visibility = welcomeOpen ? 'hidden' : '';
    if (teaser.hidden || welcomeOpen) {
      if (typeof teaser.hidePopover === 'function' && teaser.matches(':popover-open')) teaser.hidePopover();
      return;
    }
    const dialogs = [...document.querySelectorAll('dialog:modal')];
    const modal = dialogs[dialogs.length - 1];
    const parent = modal || document.body;
    if (teaser.parentElement !== parent) {
      if (typeof teaser.hidePopover === 'function' && teaser.matches(':popover-open')) teaser.hidePopover();
      parent.append(teaser);
    }
    if (typeof teaser.showPopover === 'function') {
      if (!teaser.matches(':popover-open')) teaser.showPopover();
    } else {
      const rect = modal?.getBoundingClientRect();
      teaser.style.left = `${rect ? -rect.left : 0}px`;
      teaser.style.top = `${innerHeight * 0.47 - (rect?.top || 0)}px`;
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(render);
  }

  async function closeCart(controller) {
    let timer;
    let onPop;
    const settled = history.state?.cartDrawerOpen
      ? new Promise(resolve => {
        onPop = () => { clearTimeout(timer); resolve(); };
        window.addEventListener('popstate', onPop, { once: true });
        timer = setTimeout(resolve, 800);
      })
      : Promise.resolve();
    await controller.closeDialog();
    await settled;
    if (onPop) window.removeEventListener('popstate', onPop);
  }

  function restoreCart() {
    const controller = returnCart;
    returnCart = null;
    if (controller?.isConnected && typeof controller.showDialog === 'function') {
      controller.showDialog();
      requestAnimationFrame(() => {
        render();
        button.focus({ preventScroll: true });
      });
    } else {
      button.focus({ preventScroll: true });
    }
  }

  button.addEventListener('click', async event => {
    if (button.hasAttribute('data-welcome-v2-opener')) return;
    event.stopPropagation();
    if (busy) return;
    const existingForm = document.querySelector(`[data-testid="klaviyo-form-${formId}"]`);
    if (existingForm?.getClientRects().length) {
      existingForm.querySelector('input, button')?.focus({ preventScroll: true });
      return;
    }
    busy = true;
    if (status) status.textContent = '';
    const modal = teaser.closest('dialog:modal');
    let controller = modal?.parentElement;
    while (controller && typeof controller.closeDialog !== 'function') controller = controller.parentElement;
    render();
    try {
      if (controller && typeof controller.closeDialog === 'function') {
        if (controller.matches('cart-drawer-component')) returnCart = controller;
        await closeCart(controller);
      } else if (modal) {
        modal.close();
      }
      failureTimer = setTimeout(() => {
        busy = false;
        render();
        restoreCart();
        if (status) status.textContent = button.dataset.errorMessage;
      }, 10000);
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    } catch {
      clearTimeout(failureTimer);
      busy = false;
      render();
      restoreCart();
      if (status) status.textContent = button.dataset.errorMessage;
    }
  });

  window.addEventListener('klaviyoForms', async event => {
    const detail = event.detail || {};
    if (detail.formId === formId) {
      if (detail.type === 'open') {
        clearTimeout(failureTimer);
        busy = false;
        const controller = document.querySelector('.cart-drawer__dialog[open]')?.closest('cart-drawer-component');
        if (controller && !returnCart && typeof controller.closeDialog === 'function') {
          returnCart = controller;
          await closeCart(controller);
        }
      }
      if (detail.type === 'close') {
        clearTimeout(failureTimer);
        busy = false;
        render();
        restoreCart();
      }
      if (detail.type === 'redirectedToUrl') returnCart = null;
    }
    schedule();
  });

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open', 'class', 'aria-modal', 'hidden'],
  });
  document.addEventListener('toggle', schedule, true);
  document.addEventListener('cart:update', schedule);
  window.addEventListener('resize', schedule);
  render();
})();
